import React from "react";
// REDUX
import { useSelector } from "react-redux";
// NAVIGATION
import { useLocation } from "react-router-dom";
// CUSTOM HOOKS
import useGetOneAdapter from "../../../../customHooks/GET_requests/useGetOneAdapter";
// COMPONENTS
import ActionsTable from "./ActionsTable";
// INTERFACES
import { RootState } from "../../../../app/store";

export default function ActionPage() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const location = useLocation();
	const adapterId = new URLSearchParams(location.search).get("idAdapter");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */
	const { adapter, isLoadingGetOneAdapter } = useGetOneAdapter({ id: adapterId ?? "" });

	// ************************************************ */
	// HELPERS **************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// USE MEMO *************************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE CALLBACK *********************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{adapter?.lift_type === "ELEVATOR" && (
				<div className={`layout__contentPage__${theme} mt-3`}>
					<ActionsTable adapter={adapter} isLoading={isLoadingGetOneAdapter} />
				</div>
			)}
		</div>
	);
}
